





































import Vue from 'vue';

import { apiProvider } from './api';

export default Vue.extend({
	name: 'CustomerFeedback',
	data() {
		return {
			feedbackDetails: {
				FeedbackguId: '' as string,
				IsSubmitted: false as boolean,
				IsExpired: false as boolean,
				FeedbackQuestions: [] as any[],
				RatingScale: 0 as number,
			},
			message: this.LocalizeChyboveHlasky('LoadingMsg') as string,
			ratingScale: 0 as number,
		};
	},
	async created() {
		const param = this.$route.query.guid.toString();
		const { tenant } = this.$route.query;
		const { data: customerRating } = await apiProvider.getDetailsForFeedback(param, tenant);
		this.feedbackDetails = customerRating;
		this.ratingScale = this.feedbackDetails.RatingScale;
		if (!this.feedbackDetails.IsSubmitted || !this.feedbackDetails.IsExpired) {
			this.message = '';
		}
	},
	methods: {
		async submitFeedback() {
			const { tenant } = this.$route.query;
			await apiProvider.submitFeedback(this.feedbackDetails, tenant);
			this.message = this.LocalizeLocal('CustomerSuccess');
			this.feedbackDetails.IsSubmitted = true;
		},
	},
});
